<template>
  <div>
    <div class="menuFrame">
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span>
            <em name="Exhibition"></em> <span>/</span>Send e-Newsletter
          </div>
          <div>
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <div class="MbDevice">
        <div class="homeLeft mt-5">
          <div class="UserAccount ml-1">
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ eExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="articleEn">
        <div class="contentBox">
          <div>
            <!-- left -->
            <div class="proLeft NoShowInMobile align_c">
              <img src="@/assets/images/iconEdm.svg" width="100%" />
            </div>
            <!-- left end -->
            <!-- right -->
            <div class="proRight">
              <div class="MbDevice">
                <!-- <h1><img src="@/assets/images/iconEdm.svg" width="35px" class="mb-1" /> Send e-Newsletter</h1> -->

                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="@/assets/images/iconEdm.svg"
                      width="35px"
                      class="mt-1 mr-1"
                    />
                  </div>
                  <div>
                    <h1>Send e-Newsletter</h1>
                  </div>
                </div>
              </div>
              <div class="PcDevice">
                <h1>Send e-Newsletter</h1>
              </div>
              <p class="my-3">&nbsp;</p>
              <p>
                Step1. Enter your email address in the field below and click
                send
              </p>
              <p>
                Step2. You will receive a e-newsletter and you can foward it to
                others.
              </p>
              <p class="my-3">&nbsp;</p>
              <form id="form" name="_method" @submit.prevent="submitEDM">
                <input type="hidden" name="RegNo" />
                <input type="hidden" name="Lang" value="tw" />
                <p class="formTitle">Language <span class="red">*</span></p>
                <input
                  type="radio"
                  name="eLang"
                  class="largeItem"
                  value="en"
                  v-model="edmLan"
                />
                English &nbsp;
                <input
                  type="radio"
                  name="E_Lang"
                  value="tw"
                  class="largeItem ml-2"
                  v-model="edmLan"
                />
                Chinese
                <p class="my-3">&nbsp;</p>
                <p class="formTitle">Email <span class="red">*</span></p>
                <input
                  type="email"
                  name="InviteEmail"
                  class="textStyle midText"
                  maxlength="50"
                  placeholder="Email Address Here"
                  v-model="edmMail"
                  required
                />

                <p class="my-3">&nbsp;</p>
                <input type="submit" value="Send" class="btnStyle" />
              </form>
            </div>
            <p class="clear"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  components: {},

  metaInfo() {
    return {
      title: `Send e-Newsletter - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      edmMail: "",
      edmLan: "en",
      lang: "en",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
    };
  },

  methods: {
    submitEDM() {
      const vm = this;

      const url = "/apiExhibitors/ShowPreview/";

      const info = {
        RegNo: vm.RegNo,
        InviteEmail: vm.edmMail,
        E_Lang: vm.edmLan,
        CSRF: vm.CSRF_Token,
      };

      // console.log(info)

      if (vm.lang == "tw") {
        if (!vm.edmMail) {
          alert("輸入欄位不完整，請重新檢查！");
        } else {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert(`展前快訊 EDM 已寄至您填寫的信箱！ \n ${vm.edmMail}`);

              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/upgradeEdm?no=${vm.RegNo}`;
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("您輸入的Email格式錯誤！");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/upgradeEdm?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("您輸入的Email格式錯誤！");

              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/upgradeEdm?no=${vm.RegNo}`;
            } else if (response.data.Code == 254) {
              alert("此為加值參展商專屬功能！");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/upgradeEdm?no=${vm.RegNo}`;
            }
          });
        }
      } else {
        if (!vm.edmMail) {
          alert("There are incomplete fields, please check again.");
        } else {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert(
                `Show Preview e-Newsletter has been sent to your email!  \n ${vm.edmMail}`
              );

              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgradeEdm?no=${vm.RegNo}`;
            } else if (response.data.Code == 251) {
              alert("System is busy, please try again later.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgradeEdm?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("The email you entered is incorrect.");

              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgradeEdm?no=${vm.RegNo}`;
            } else if (response.data.Code == 254) {
              alert("This function is for Paid Service.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgradeEdm?no=${vm.RegNo}`;
            } else if (response.data.Code == 500) {
              alert("System is busy, please try again later.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgradeEdm?no=${vm.RegNo}`;
            }
          });
        }
      }
    },
  },

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    let lang = "en";

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${lang}`
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
      });

    // $(function () {
    //   $('#form').validate({
    //     errorPlacement: function (error, element) {
    //       if (element.is('.errorItem')) {
    //         error.appendTo(element.parents('.errorContainer'))
    //       } else {
    //         error.insertAfter(element)
    //       }
    //     },
    //   })
    // })
  },
};
</script>

<style>
.LoadingTextEn {
  font-size: 22px;
  font-weight: bold;
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
  justify-content: center;
}
</style>
